import * as _ from 'underscore';

import ACTIONS from '../actions';
import { getState } from '../../../store';
import * as Utils from '../../../../lib/designerUtils';

const dayTree = (state = {}, action) => {
    let newState = {};
    let key = null;
    let sessions = [];
    switch (action.type) {
        case ACTIONS.CALENDAR_SETUP:
            let days = {
                ...state
            };
            for (let key in action.payload.entities.days) {
                if (days[key]) continue;
                days[key] = Object.freeze(action.payload.entities.days[key]);
            }
            return days;
        case ACTIONS.CALENDAR_ADD_PROGRAM_WORKOUTS:
            newState = {
                ...state
            };
            let dateGroups = _.groupBy(
                action.payload.entities.sessions,
                'date'
            );
            _.forEach(dateGroups, group => {
                group = _.sortBy(group, 'title');
                group.map(session => {
                    const sessionKey = session.workout_id;
                    const dayKey = Utils.getDayKey(session);
                    if (!dayKey || !newState[dayKey]) return;
                    let items = newState[dayKey].items;
                    const newItem = parseInt(sessionKey, 10);
                    items = [...items, newItem];
                    items = _.without(items, 'fakeSession');
                    items = _.uniq(items);
                    newState[dayKey] = {
                        ...newState[dayKey],
                        items
                    };
                });
            });
            return newState;
        case ACTIONS.DAYS_CLEAR:
            return {};
        case ACTIONS.DAYS_RELOAD:
            return {
                ...state,
                ...action.payload.entities.days
            };
        case ACTIONS.SESSION_COPY:
        case ACTIONS.SESSION_ADD:
            key = Utils.getDayKey(action.day);
            let items = [...state[key].items, action.session.workout_id];
            items = _.without(items, 'fakeSession');
            items = _.uniq(items);
            newState = {
                ...state,
                [key]: {
                    ...state[key],
                    items
                }
            };
            return newState;
        case ACTIONS.DND_CAL_SESSION:
            key = action.targetDayKey;
            let fromKey = action.fromDayKey;

            let fromDay = state[fromKey].items;
            let fromLen = fromDay.length;
            let fromItems = [];
            for (let i = 0; i < fromLen; i++) {
                if (fromDay[i] !== action.session.workout_id) {
                    fromItems.push(fromDay[i]);
                }
            }
            let toDay = state[key].items;
            let toLen = toDay.length;
            let toItems = [];
            for (let i = 0; i < toLen; i++) {
                toItems.push({
                    id: toDay[i],
                    title: getState().calendar.sessionTree[toDay[i]].data.title
                });
            }
            toItems.push({
                id: action.session.workout_id,
                title: getState().calendar.sessionTree[
                    action.session.workout_id
                ].data.title
            });
            toItems = _.sortBy(toItems, i => i.title);
            const sortedItems = [];
            for (let i = 0; i < toItems.length; i++) {
                sortedItems.push(toItems[i].id);
            }
            newState = {
                ...state,
                [fromKey]: {
                    ...state[fromKey],
                    items: fromItems
                },
                [key]: {
                    ...state[key],
                    items: sortedItems
                }
            };
            return newState;
        case ACTIONS.DND_CAL_SESSION_ORDER:
            key = action.dayKey;
            newState = {
                ...state,
                [key]: {
                    ...state[key],
                    items: action.newOrder
                }
            };
            return newState;
        case ACTIONS.SESSION_DELETE:
            key = Utils.getDayKey(action.day);
            for (let i = 0; i < state[key].items.length; i++) {
                if (state[key].items[i] !== action.session.workout_id) {
                    sessions.push(state[key].items[i]);
                }
            }
            newState = {
                ...state,
                [key]: {
                    ...state[key],
                    items: sessions
                }
            };
            return newState;
        case ACTIONS.SESSION_DELETE_UNDO:
            key = Utils.getDayKey(action.day);
            sessions = [...state[key].items];
            sessions.push(action.session.data.workout_id);

            newState = {
                ...state,
                [key]: {
                    ...state[key],
                    items: sessions
                }
            };
            return newState;
        case ACTIONS.CALENDAR_ADD_FAKE_SESSION:
            key = Utils.getDayKey(action.day);
            sessions = [...state[key].items];
            sessions.push('fakeSession');

            newState = {
                ...state,
                [key]: {
                    ...state[key],
                    items: sessions
                }
            };
            return newState;
        case ACTIONS.CALENDAR_PROGRAM_UPDATE_LENGTH:
            const totalDays =
                action.weeksLength === 1 ? 7 : action.weeksLength * 7;
            const oldStateSize = Object.keys(state).length;
            const ns = {};
            for (let i = 0; i <= totalDays; i++) {
                const week = Math.floor(i / 7);
                const day = Math.abs(week * 7 - i);
                const weekDayKey = `${week}_${day}`;
                if (i < oldStateSize) {
                    ns[weekDayKey] = state[weekDayKey];
                }
                if (i >= oldStateSize) {
                    ns[weekDayKey] = {
                        contextTitle: `Week ${week}, Day ${day}`,
                        index: day,
                        items: [],
                        numItems: 0,
                        timelineDay: day + 1,
                        title: day + 1,
                        weekIndex: week
                    };
                }
            }
            return ns;
        default:
            return state;
    }
};

export default dayTree;



// WEBPACK FOOTER //
// ./src/state/reducer/calendar/reducer/dayTree.js